import React from 'react';

import { ProductButtonProps } from '../../../../../../../BatchTicket/components/DynamicButton';
import { ApplicationButton } from '../../components/ApplicationButton';

export const ClubsButton: React.FC<ProductButtonProps<'clubs'>> = (props) => {
  return <ApplicationButton {...props} idSelector="clubId" />;
};
